// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21fzB","index":"styles_index__2JtdL"};